<section class="section-pd">
    <div class="trinka_container">
        <div class="secure-wrapper">
            <div class="row align-items-center match-box">
                <div class="col-md-6 col-lg-7 dflex">
                    <div class="trinka-title mb-0">
                        <h2>コンテンツの<br/>
                            プライバシー保護機能も</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>機密データ保護プランでは、高度なセキュリティで、ユーザーのデータを保護します。</p>
                        <ul>
                            <li>ユーザーのデータはシステムから即時削除</li>
                            <li>ユーザーのデータによるAI学習なし</li>  
                            <li>ユーザー自身がデータをコントロール</li>     
                        </ul>
                        <div class="btn-group">
                            <a href="/enterprise/confidential-data-plan-for-grammar-checker" class="filled-btn">詳細はこちら</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-5 dflex ">
                    <div class="text-center">
                        <!-- <picture>
                            <source srcset="../../../assets/images/homepage/data-security.webp" type="image/webp">
                            <img src="../../../assets/images/homepage/data-security.jpg" loading="lazy" decoding="async" alt="data-security">
                        </picture> -->
                        <img src="assets/images/homepage/data-security.svg" class="img-fluid" loading="lazy" decoding="async" alt="data-security">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>